import { useRouter } from 'next/router';
import { type RpcRangeOrder } from '@/shared/utils/orders';
import { useCloseRangeOrder } from '../../hooks/useCloseRangeOrder';
import { OrdersTableDropdown } from '../Orders/OrdersTableDropdown';

export const RangeOrderAdditionalCell = ({ order }: { order: RpcRangeOrder }) => {
  const { mutate: closeRangeOrder } = useCloseRangeOrder(order);
  const router = useRouter();

  return (
    <OrdersTableDropdown
      onRedirect={() =>
        router.push(new URL(`/pools/${order.asset}`, process.env.NEXT_PUBLIC_EXPLORER_URL))
      }
      onClose={closeRangeOrder}
    />
  );
};
